import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/usr/src/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/public/img/no-image.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/modules/cms/components/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/modules/cms/components/DOMRenderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/modules/cms/components/NewsletterSubscriptionForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/modules/portal/components/MaintenanceSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/modules/portal/components/products/CuttingInfo.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/modules/shop/components/ProductAvailability.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/modules/shop/components/ProductPriceInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","BannerSlider"] */ "/usr/src/app/src/modules/theme/components/Banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/modules/theme/components/BubbleLinkWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/modules/theme/components/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/modules/theme/components/PageMenuWithTabList.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/modules/theme/components/RecentThemeCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/modules/theme/components/Tooltip.jsx");
